














































































import OSS from "ali-oss";
import { getOSSConfig } from "@/api/ossImageUploader";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() oriImage!: any;
  @Prop() preview!: any;
  @Prop() size!: any;
  @Prop() clearMark!: any;
  @Prop() multiple!: any;
  @Prop() types!: any;
  @Prop() listClear!: any; //提交的时候清空数组
  @Watch("clearMark", { immediate: false, deep: false })
  clearMarks(n: any, o: any) {
    // console.log(!n,o)
    if (!n && o) {
      this.imageUrl = "";
    } else {
      this.imageUrl = this.oriImage;
    }
  }
  @Watch("listClear", { immediate: false, deep: false })
  listClears(n: any, o: any) {
    const _t = this as any;
    if (!n && o) {
      _t.$refs.pictureUpload.uploadFiles = [];
    }
  }
  client = null;
  prefix = "";
  cdn_url = "";
  callback = {};
  imageUrl = this.oriImage;
  piclist = [];
  type = this.types;
  disabled = false;
  dialogVisible = false;
  dialogImageUrl = "";
  chooseImg(e: any) {
    const self = this as any;
    getOSSConfig().then((res: any) => {
      // 注意前缀路径prefix的值每次请求token时都会改变，所以同一个上传请求不需要重新请求token，实现覆盖上传
      // 不同上传请求则需要每次重新获取token
      if (res.error_code == 0) {
        self.prefix = res.data.object_name_prefix;
        self.cdn_url = res.data.cdn_url;
        self.callback = res.data.callback;
        self.client = new OSS({
          accessKeyId: res.data.access_key_id,
          accessKeySecret: res.data.access_key_secret,
          stsToken: res.data.security_token,
          region: "oss-cn-shenzhen",
          bucket: res.data.bucket,
        });
        self.client
          .put(self.prefix + e.file.name, e.file, {
            callback: {
              url: self.callback.callback_url,
              host: self.callback.callback_host,
              body: self.callback.callback_body,
              contentType: self.callback.callback_body_type,
            },
          })
          .then(function (result: any) {
            if (result.data.code == "Ok") {
              if (self.preview) {
                self.imageUrl = self.cdn_url + "/" + result.data.object;
              }
              self.$emit("set-img-url", result);
              self.$message({
                type: "success",
                message: "上传成功!",
              });
            }
          })
          .catch(function (err: any) {});
      }
    });
  }
  exceedClick(e: any) {
    this.$message({
      type: "error",
      message: "最多只上传9个!",
    });
  }
  beforeAvatarUploadtwo(file: any) {
    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isLt2M) {
      this.$message.error("上传图片大小不能超过 10MB!");
    }
    return isLt2M;
  }
  beforeAvatarUpload(file: any) {
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      this.$message.error("上传图片大小不能超过 5MB!");
    }
    return isLt2M;
  }
  //图片上传
  handleRemove(file: any) {
    const _t = this as any;
    const pictureUploadList = _t.$refs.pictureUpload.uploadFiles;
    for (let i = 0; i < pictureUploadList.length; i++) {
      if (pictureUploadList[i].url == file.url) {
        _t.$emit("del-img", i);
        pictureUploadList.splice(i, 1);
      }
    }
  }
  handlePictureCardPreview(file: any) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
}
